export default {
  EMAIL_REGEX: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/, //eslint-disable-line
  PHONE_REGEX: /^(\+?\d{1,3}?)?[- .]?\(?(?:\d{2,3})\)?[- .]?\d\d\d[- .]?\d\d\d\d$/,
  DNIF_REGEX: /(^\d{8}[A-Z]{1}$)|(^[A-Z]{1}\d{8}$)|(^\d{8}[a-z]{1}$)|(^[a-z]{1}\d{8}$)/,
  AGE_REGEX: /^\d{1,2}$/,
  PRICE_REGEX: /^[0-9]([0-9]+)?(\.[0-9][0-9])?$/,
  REQUIRED_FIELD: 'El campo es obligatorio',
  INVALID_EMAIL: 'El email introducido no es válido',
  INVALID_PHONE: 'El teléfono introducido no es válido',
  INVALID_DNI: 'El DNI introducido no es válido',
  INVALID_AGE: 'La edad introducida no es válida',
  PASSWORDS_NOT_MATCH: 'Las contraseñas no coinciden',
  NOT_TERMS_AND_CONDITIONS: 'Debe aceptar los términos',
  PAST_DATE: 'La fecha no puede ser pasada',
  FUTURE_DATE: 'La fecha no puede ser futura',
  DATE_FORMAT: 'La fecha debe tener el formato \'12/08/1994\'',
  NOT_TODAY: 'La fecha debe ser posterior al día actual'
};



// WEBPACK FOOTER //
// ./src/constants/validation.js